module.exports = __webpack_public_path__ + "static/media/camera.1ca0a16b.svg";